import { Home, QrCode, ScanLine, SlidersHorizontal } from "lucide-react";
import { NavLink } from "react-router-dom";

const destinations = [
  { to: "/app", label: "La mia taglia", icon: Home, end: true },
  { to: "/app/scan", label: "Foto", icon: ScanLine, end: false },
  { to: "/app/style", label: "Stile", icon: SlidersHorizontal, end: false },
  { to: "/app/pass", label: "Il mio QR", icon: QrCode, end: false },
] as const;

export function ConsumerBottomNav() {
  return <nav className="consumer-bottom-nav" aria-label="Mobile app navigation">
    {destinations.map(({ to, label, icon: Icon, ...item }) => <NavLink key={to} to={to} end={item.end} aria-label={label}>
      <Icon aria-hidden="true" />
      <span>{label}</span>
    </NavLink>)}
  </nav>;
}
